import { render, staticRenderFns } from "./UniList.vue?vue&type=template&id=0e4d92f9&scoped=true&"
import script from "./UniList.vue?vue&type=script&lang=js&"
export * from "./UniList.vue?vue&type=script&lang=js&"
import style0 from "./UniList.vue?vue&type=style&index=0&id=0e4d92f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4d92f9",
  null
  
)

export default component.exports